"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LearningTableBodyEmptyRow = void 0;
var React = require("react");
var LearningTableBodyDescriptionCell_1 = require("./LearningTableBodyDescriptionCell");
var LearningTableBodyEmptyRow = function (_a) {
    var isMobile = _a.isMobile, columnQuantity = _a.columnQuantity;
    return (React.createElement("tbody", { className: "screen-reader-only" },
        React.createElement("tr", { className: "learning-table-body-description-row ", tabIndex: -1 },
            React.createElement(LearningTableBodyDescriptionCell_1.LearningTableBodyDescriptionCell, { cellInfo: { description: '' }, buttonLabel: "-", isMobile: isMobile, isInvisible: true, columnQuantity: columnQuantity, isEmpty: true }))));
};
exports.LearningTableBodyEmptyRow = LearningTableBodyEmptyRow;
